import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MoviesService } from '../services/movies.service';
import * as $ from"jquery"

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
myMovies ; searchValue:string  ; searchedMovie :any[]
  constructor(private _router:Router , private _activatedroute:ActivatedRoute , private movies:MoviesService) 
  { 
  
    this._activatedroute.params.subscribe(params => {
      this.searchValue = params['search'];
      // reset and set based on new parameter this time
      this.searchedMovie = []
      this.myMovies = this.movies.movies
      });
      if(this.searchValue === " ")
      {
        this.searchedMovie = this.myMovies
      }
      else
      {
        for(let item of this.myMovies )
        {
          if(item. movieName.indexOf(this.searchValue.toUpperCase()) != -1)
          {
            this.searchedMovie.push(item)
          }
        }
      }
     

   
  }

  ngOnInit() {

    this._activatedroute.params.subscribe(params => {
      this.searchValue = params['search'];
      this.searchedMovie  = []
      // reset and set based on new parameter this time
      this.myMovies = this.movies.movies
      if(this.searchValue === "")
      {
        this.searchedMovie = this.myMovies ; 
      }
      else{

        for(let item of this.myMovies )
        {
          console.log(item)
          console.log(item.movieName.indexOf(this.searchValue.toUpperCase()))
          if(item.movieName.indexOf(this.searchValue.toUpperCase()) != -1)
          {
            
            this.searchedMovie.push(item)
            
          }
        }
      }
    
      
      });

      $(document).ready(function(){
        $("body").on("click",".accor li",function(){
          if($(this).attr("id") == "1")
          {
           $(".firs").css("display","block");
            $(".sec").css("display","none");  
             $(this).addClass("act");
             $(this).siblings().removeClass("act"); 
            
        
          
          }
          else
          {
            
            $(".sec").css("display","block");
            $(".firs").css("display","none"); 
            $(this).addClass("act");
             $(this).siblings().removeClass("act"); 
          
          }
        });

        });
      
      
  }

  search()
  {
    var searchValue = (<HTMLInputElement>document.getElementById('searchValue')).value ; 
    (<HTMLInputElement>document.getElementById('searchValue')).value = ""
    this._router.navigate(["/Movie/Search",searchValue.toUpperCase()]);

  }
  goToType(type)
  {
    this._router.navigate(["/Movie/Type",type.toUpperCase()]);
  }
  goToDetails(id)
  {
    this._router.navigate(["/Movie/Details",id]);
  }
}
